// Load all the components of the TosRUs lightbox
require('jQuery.TosRUs/src/js/jquery.tosrus');

// require('jQuery.TosRUs/src/js/addons/jquery.tosrus.autoplay');
require('jQuery.TosRUs/src/js/addons/jquery.tosrus.buttons');
require('jQuery.TosRUs/src/js/addons/jquery.tosrus.caption');
require('jQuery.TosRUs/src/js/addons/jquery.tosrus.drag');
require('jQuery.TosRUs/src/js/addons/jquery.tosrus.keys');
require('jQuery.TosRUs/src/js/addons/jquery.tosrus.pagination');

// require('jQuery.TosRUs/src/js/media/jquery.tosrus.html');
// require('jQuery.TosRUs/src/js/media/jquery.tosrus.image');
// require('jQuery.TosRUs/src/js/media/jquery.tosrus.vimeo');
// require('jQuery.TosRUs/src/js/media/jquery.tosrus.youtube');




/*****************
 ** WEBPACK FOOTER
 ** ./lib/tosrus/index.js
 ** module id = 78
 ** module chunks = 0
 **/